import React, { useState } from "react";
import AppButton from "../layout/AppButton";

const PersonaRegistrationsForm = ({ onCreatePersona, loading = false }) => {
  const [personaName, setPersonaName] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const trimmedName = personaName.trim();
    if (!trimmedName) {
      return;
    }

    onCreatePersona(trimmedName);
  };

  return (
    <div className="rr-wrap pb-4">
      <div className="rr-card">
        <div className="rr-cardHeader">
          <p className="rr-kicker">Persona Intake</p>
          <h5 className="rr-title">Persona Registration</h5>
          <p className="rr-subtitle">
            Create a new persona by entering the persona name.
          </p>
        </div>

        <div className="rr-content">
          <div className="rr-sidePanel">
            <div className="rr-sideBadge">Info</div>
            <ul className="rr-checklist">
              <li>Use a clear and unique persona name.</li>
              <li>Persona names are case-insensitive for duplicates.</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-3 rr-formGrid">
              <div className="col-12">
                <label htmlFor="personaName" className="form-label rr-label">
                  Persona Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="personaName"
                  disabled={loading}
                  name="personaName"
                  type="text"
                  className="form-control rr-input"
                  placeholder="Enter persona name"
                  value={personaName}
                  onChange={(event) => setPersonaName(event.target.value)}
                  required
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-4 rr-actions justify-content-end">
              <AppButton type="reset" variant="secondary" onClick={() => setPersonaName("")} disabled={loading}>Clear</AppButton>
              <AppButton type="submit" variant="fill" disabled={!personaName.trim() || loading}>
                {loading ? "Creating..." : "Create Persona"}
              </AppButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PersonaRegistrationsForm;
